import React from 'react';
import { Option } from '../control/option';
import FormSelect from './FormSelect';
import contacts from '../../api/contacts';

type Props = {
    id: string;
    clientId: number;
    readOnly?: boolean;
};

const ClientContacts: React.FC<Props> = ({ id, clientId, readOnly }) => {
    const loadOptions = (inputValue: string, callback: (options: Option[]) => void) => {
        contacts
            .clientOptions({
                filter: inputValue,
                clientId: clientId,
            })
            .then((options) => callback(options));
    };
    return (
        <FormSelect id={id} loadOptions={loadOptions} cacheOptions={false} readOnly={readOnly} />
    );
};

export default ClientContacts;
